// Generated by scripts/bump-version-pre-commit.js.
// Do not edit manually.

export default function getVersion(): string {
    return '2.60.132-feature_style_line_width_units.88c3c2a6';
}
